import React from 'react'
import Text from '../Typography/Text'

const CellNumber = ({ number }) => {
  return <Text>{Number(number).toLocaleString('es-CL')}</Text>
}

export default CellNumber
